import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import Faq from './Component/Faq/faq';
import Page1 from './Component/Faq/page1';
import Page2 from './Component/Faq/page2';
import PrivacyPolicy from './Component/Others/PrivacyPolicy';
import Pdf from './Component/Others/manual';
import UserAgreement from './Component/Others/UserAgreement';
import Download from './Component/Others/download';
import intro from './Component/Guide/introduction';
import install from './Component/Guide/install';
import use from './Component/Guide/use';
import maintenance from './Component/Guide/maintenance';
import others from './Component/Guide/others';
import effect from './Component/Help/effect';
import cooperation from './Component/Help/cooperation';
import share from './Component/Help/share';
import overview from './Component/Help/overview';




class RouterConfig extends React.Component {
  render() {
    return (
      <Router basename="/s5c/">
        <div>
          {/* 常见问题 */}
          <Route exact path="/faq" component={Faq} />

          {/* 产品指南页面 */}
          {/* 产品介绍 */}
          <Route exact path="/guide/intro" component={intro} />
          {/* 安装指南 */}
          <Route exact path="/guide/install" component={install} />
          {/* 使用说明 */}
          <Route exact path="/guide/use" component={use} />
          {/* 日常维护 */}
          <Route exact path="/guide/maintenance" component={maintenance} />
          {/* 其他信息 */}
          <Route exact path="/guide/others" component={others} />

          {/* 帮助中心 */}
          {/* 效果实现 */}
          <Route exact path="/help/effect" component={effect} />
          {/* 企业合作 */}
          <Route exact path="/help/cooperation" component={cooperation} />
          {/* 项目分享 */}
          <Route exact path="/help/share" component={share} />
          {/* 项目预览 */}
          <Route exact path="/help/overview" component={overview} />

          {/* <Route path="/faq/page1" component={Page1} />
          <Route path="/faq/page2" component={Page2} /> */}
          {/* 隐私协议 */}
          <Route path="/PrivacyPolicy" component={PrivacyPolicy} />
          {/* 用户协议 */}
          <Route path="/UserAgreement" component={UserAgreement} />
          {/* 说明书 */}
          <Route path="/manual" component={Pdf} />
        </div>
      </Router>
    )
  }
}

export default RouterConfig;